import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { loginPathWithRedirect } from '../constants/routes';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const loadingStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={loadingStyles} aria-live="polite">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve the destination the user was trying to reach (e.g. a deep link
    // to /ar-contacts from the Vue menu) so Login can return them there after
    // a successful sign-in instead of dropping them on the default dashboard.
    const attempted = `${location.pathname}${location.search}`;
    return <Navigate to={loginPathWithRedirect(attempted)} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
